import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BasicLayoutComponent } from './basic-layout/basic-layout.component';
import { LayoutsRoutingModule } from './layouts-routing.module';
import { SharedModule } from '../modules/shared.module';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { BasicLayoutHeaderComponent } from './basic-layout/basic-layout-header/basic-layout-header.component';
import { BasicLayoutFooterComponent } from './basic-layout/basic-layout-footer/basic-layout-footer.component';
import { BasicLayoutHeaderLinksComponent } from './basic-layout/basic-layout-header-links/basic-layout-header-links.component';
import { BasicLayoutHamburgerMenuComponent } from './basic-layout/basic-layout-hamburger-menu/basic-layout-hamburger-menu.component';
import { BasicLayoutHamburgerControlComponent } from './basic-layout/basic-layout-hamburger-control/basic-layout-hamburger-control.component';
import { BasicLayoutFooterLinksComponent } from './basic-layout/basic-layout-footer-links/basic-layout-footer-links.component';
import { BasicLayoutNativeBottomBarComponent } from './basic-layout/basic-layout-native-bottom-bar/basic-layout-native-bottom-bar.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    LayoutsRoutingModule,
    TranslatePipe,
    TranslateDirective,
    AngularSvgIconModule,
  ],
  exports: [],
  declarations: [
    BasicLayoutComponent,
    BasicLayoutHeaderComponent,
    BasicLayoutFooterComponent,
    BasicLayoutHeaderLinksComponent,
    BasicLayoutHamburgerMenuComponent,
    BasicLayoutHamburgerControlComponent,
    BasicLayoutFooterLinksComponent,
    BasicLayoutNativeBottomBarComponent,
  ]
})
export class LayoutsModule { }